import React, { useState, useEffect } from "react";
import axios from "axios";
import { ParticipantAnalytics } from "../../../services";
import { LineGraph, PieChart, Select } from "../../../components";

const data1 = [
  {
    timestamp: new Date(1609545600000).toLocaleDateString("en-US"),
    value: 1206.45,
  },
  {
    timestamp: new Date(1610150400000).toLocaleDateString("en-US"),
    value: 1206,
  },
  {
    timestamp: new Date(1610323200000).toLocaleDateString("en-US"),
    value: 1206,
  },
  {
    timestamp: new Date(1611964799000).toLocaleDateString("en-US"),
    value: 1206,
  },
];

const data2 = [
  {
    timestamp: new Date(1611964799000).toLocaleDateString("en-US"),
    value: 1235,
  },
  {
    timestamp: new Date(1610323200000).toLocaleDateString("en-US"),
    value: 1305,
  },
  {
    timestamp: new Date(1610150400000).toLocaleDateString("en-US"),
    value: 1485,
  },
  {
    timestamp: new Date(1609545600000).toLocaleDateString("en-US"),
    value: 3561,
  },
];

const PersonalInvestmentPerformance = (props) => {
  const [payload, setPayload] = useState({
    //"SelectedPeriod": "YTD",
    informationOn: "Allocation",
    groupBy: "IDFund",
    cvsSupt: true,
    whichPage: "Overview",
    DVDATAdataType: "json",
    employeeId: 1,
  });
  const optionsList = [
    {
      label: "by Asset Class",
      value: "IDAssetClass",
    },
    {
      label: "by Contribution Type",
      value: "IDSubAccount1",
    },
    {
      label: "by Fund",
      value: "IDFund",
    },
  ];
  const [data, setData] = useState([]);

  useEffect(() => {
    ParticipantAnalytics(payload).then((response) => {
      if (response != null) {
        const responseData = response?.results.map((item, index) => {
          return {
            percentage: item.pct100 * 100,
            name: item.label,
            color: item.color,
          };
        });
        setData(responseData);
      }
    });
  }, [payload]);
  return (
    <div className="d-flex flex-column">
      <h1 style={{ marginTop: "50px" }}>Participant Analytics</h1>
      <div
        className="d-flex flex-column w-75 p-5"
        style={{ border: "1px solid #bdbdbd", borderRadius: "8px" }}
      >
        <div className="d-flex flex-row justify-content-between">
          <h4>Allocation</h4>
          <div style={{ width: "30%" }}>
            <Select
              title={optionsList.find((_) => _.value == payload.groupBy).label}
              optionsList={optionsList}
              onClick={(event) => {
                setPayload({ ...payload, groupBy: event.target.value });
                // getTempEmployeeDetailsforPayroll(
                //   filteredValues[event.target.value].id
                // );
              }}
              value={optionsList.map((item, index) => {
                return {
                  label: item?.label,
                  value: item.value,
                };
              })}
            />
          </div>
        </div>
        <div className="d-flex align-self-center mt-5">
          <PieChart
            data={data}
            wrapperStyle={{ width: "400px", height: "400px" }}
          />
        </div>
      </div>
      <LineGraph dataset1={data1} dataset2={data2} />
    </div>
  );
};

export default PersonalInvestmentPerformance;
